import { render, staticRenderFns } from "./GpuDashboard.vue?vue&type=template&id=6b2481df&scoped=true"
import script from "./GpuDashboard.vue?vue&type=script&lang=js"
export * from "./GpuDashboard.vue?vue&type=script&lang=js"
import style0 from "./GpuDashboard.vue?vue&type=style&index=0&id=6b2481df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2481df",
  null
  
)

export default component.exports